// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WM69B","footer":"styles_footer__38C2v"};